import { defineStore } from 'pinia';
import type { Ref } from 'vue';
import { ref } from 'vue';

import { isNonEmptyString } from '@nora-monorepo/shared';

export enum TacticalAnnotationToolMode {
  CreateAreaPolygon,
  SelectEntrySide,
  Confirmation,
  Done,
}

function tacticalAnnotationToolStore(): {
  mode: Ref<TacticalAnnotationToolMode>;
  reset: () => void;
} {
  const mode = ref<TacticalAnnotationToolMode>(
    TacticalAnnotationToolMode.CreateAreaPolygon,
  );

  const reset = (): void => {
    mode.value = TacticalAnnotationToolMode.CreateAreaPolygon;
  };

  return {
    mode,
    reset,
  };
}

export function useTacticalAnnotationToolStore(storeId?: string | null) {
  if (!isNonEmptyString(storeId)) {
    return defineStore(
      `tacticalAnnotationToolStore`,
      tacticalAnnotationToolStore,
    )();
  }

  return defineStore(
    `tacticalAnnotationToolStore-${storeId}`,
    tacticalAnnotationToolStore,
  )();
}

export default useTacticalAnnotationToolStore;
